import { useCouponStore } from "../../store/couponStore"
import Button from "../Button";
import {FiUpload, FiDownload} from "react-icons/fi";
import React from "react";
import {exportToExcel} from "../../utils/exportToExcel";
import {formatJustDate} from "../../utils/jalaliDate";
import * as couponApi from "../../services/couponApi";
import {toast} from "react-hot-toast";
import * as XLSX from "xlsx"

export default function CouponFilters() {

  const filters = useCouponStore((s) => s.filters)
  const setFilters = useCouponStore((s) => s.setFilters)
  const fetchCoupons = useCouponStore((s) => s.fetchCoupons)
  const openForm = useCouponStore((s) => s.openForm)
  const uploadExcel = useCouponStore((s) => s.uploadExcel)


  const handleChange = (e) => {
    setFilters({
      [e.target.name]: e.target.value
    })
  }

  const handleSearch = () => {
    fetchCoupons()
  }

const handleExcelUpload = (e) => {
  const file = e.target.files[0]
  if (!file) return

  if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
    alert("فقط فایل اکسل مجاز است")
    return
  }

  const reader = new FileReader()

  reader.onload = (evt) => {

    const data = new Uint8Array(evt.target.result)
    const workbook = XLSX.read(data, { type: "array" })

    const sheet = workbook.Sheets[workbook.SheetNames[0]]

    const json = XLSX.utils.sheet_to_json(sheet)

    uploadExcel(json)
  }

  reader.readAsArrayBuffer(file)
}


  const handleExportExcel = async () => {
    const params = {
    ...filters,
    no_pagination: true
    };
    try {
      const res = await couponApi.getCoupons(params);

      const data = res?.data?.results ?? res?.data ?? [];

      const ExcelData = data.map(coupon => ({
          id: coupon.id ?? "",
          username: coupon.user?.full_name ?? "",
          userphone: coupon.user?.phone_number ?? "",
          title: coupon.title??"",
          code: coupon.code?? "",
          discount_type: coupon.discount_type?? "",
          discount_value: coupon.discount_value?? 0,
          usage_limit: coupon.usage_limit?? 1,
          usage_count: coupon.usage_count?? 0,
          min_order_amount: coupon.min_order_amount?? 0,
          max_discount_amount: coupon.max_discount_amount?? null,
          expiration_date: formatJustDate(coupon.expiration_date)?? null,
          is_active: coupon.is_active?? true,
        }));
      exportToExcel(ExcelData, `کدهای تخفیف`,{
        headers: {
          id: "کد یکتا",
          username:"نام و نام خانوادگی",
          userphone: "شماره موبایل",
          title:"عنوان",
          code:"کد",
          discount_type:"نوع تخفیف",
          discount_value:"مقدار تخفیف",
          usage_limit:"حداکثر تعداد استفاده",
          usage_count:"تعداد استفاده",
          min_order_amount:"حداقل سفارش",
          max_discount_amount:"حداکثر تخفیف",
          expiration_date:"تاریخ انقضا",
          is_active:"وضعیت فعال بودن"
        }
      })
      } catch (error) {
        console.error("Error fetching coupons:", error);

        // نمایش پیام خطا به کاربر
        const errorMessage = error.response?.data?.message || "خطا در دریافت اطلاعات کوپن‌ها";
        toast.error(errorMessage);

    }}

  return (
    <div className="bg-white p-4 rounded shadow space-y-4">

      <div className="grid grid-cols-1 gap-3
                  sm:grid-cols-2
                  lg:grid-cols-[2fr_1fr_1fr_auto_auto]
                  items-center">

        <input
            name="searchTerm"
            value={filters.searchTerm}
            onChange={handleChange}
            placeholder="جستجو ... "
            className="w-full px-4 py-2 border border-gray-300 rounded-lg
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
        <div className="flex items-center gap-2 w-full">
          <label
              className="text-sm font-medium text-gray-700 mb-2  whitespace-nowrap"
          >
             وضعیت کد:
          </label>

          <select
              name="is_active"
              value={filters.is_active}
              onChange={handleChange}
              className="flex-1 border p-2 rounded text-sm font-medium text-[#1E3A5F]"
          >
            <option value="">همه</option>
            <option value="true">فعال</option>
            <option value="false">غیرفعال</option>
          </select>
        </div>

        <div className="flex items-center gap-2 w-full">
          <label
              className="text-sm font-medium text-gray-700 mb-2"
          >
            انقضا کد:
          </label>

          <select
              name="expired"
              value={filters.expired ?? ""}
              onChange={handleChange}
              className="flex-1 border p-2 rounded text-sm font-medium text-[#1E3A5F]"
          >
            <option value="">همه</option>
            <option value="false">منقضی نشده</option>
            <option value="true">منقضی شده</option>
          </select>
        </div>
        <Button
          variant={'primary'}
          onClick={handleSearch}
          children={'جستجو'}/>

        </div>

      <div className="flex items-center justify-between">

        {/* دکمه افزودن */}
        <Button
            variant="primary"
            onClick={() => openForm()}
            children={"افزودن کد تخفیف"}
        />

        {/* دکمه های اکسل */}
        <div className="flex items-center gap-3">

          <label
              className="flex items-center gap-2 bg-[#F5F5F5] text-[#1E3A5F] hover:bg-[#DBDBDB] hover:text-[#12233A] px-4 py-2 rounded-[8px] cursor-pointer">
            <FiUpload className="w-5 h-5"/>
            <span>بارگذاری اکسل</span>

            <input
                type="file"
                onChange={handleExcelUpload}
                className="hidden"
            />
          </label>

          <Button
              variant="secondary"
              onClick={handleExportExcel}
              icon={<FiDownload className="w-5 h-5"/>}
              children={"خروجی اکسل"}
          />

        </div>

      </div>

    </div>
  )
}
